(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/components/game-launcher/game-launcher-leia.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/components/game-launcher/game-launcher-leia.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  useEffect,
  useRef
} = React;
const defaultResize = container => {
  container.style.height = "".concat(window.innerHeight, "px");
  container.style.width = "".concat(window.innerWidth, "px");
};
const defaultListener = (eventName, eventData) => {
  dispatchEvent(new CustomEvent(eventName, {
    detail: eventData
  }));
};
const GameLauncherLeia = _ref => {
  let {
    children,
    className = '',
    gameSpecificParameters,
    onResize = defaultResize,
    listener = defaultListener
  } = _ref;
  const {
    ticketInfo,
    isDemo,
    betId,
    isEInstant = false,
    voucherCode = null,
    dispatch
  } = svs.ticketgames.ticketUtility.components.useGameContext();
  const {
    soundEnabled
  } = svs.ticketgames.ticketUtility.utils.useSoundEnabled({
    ticketInfo
  });
  const {
    demoLoadingMsg
  } = svs.ticketgames.ticketUtility.utils.useAccessibilityStatus({
    isEInstant
  });
  const {
    VOUCHER,
    WEB
  } = svs.ticketgames.ticketUtility.utils.constants.leia.lotteryChannel;
  const falcon = svs.ticketgames.falconBridge.falcon;
  const HostChannel = svs.ticketgames.falconBridge.HostChannel;
  const {
    hostKey,
    bridgeLocation
  } = svs.falconBridge && svs.falconBridge.data.environment || {};
  const gameRef = useRef(null);
  useEffect(() => {
    if (gameRef.current) {
      dispatch && dispatch({
        type: 'SET_GAME_REF',
        payload: gameRef
      });
    }
  }, [gameRef, dispatch]);
  useEffect(() => {
    const lazyOnResizeTicket = _.debounce(() => {
      onResize(gameRef.current);
    }, 50);
    window.addEventListener('resize', lazyOnResizeTicket);
    return () => {
      window.removeEventListener('resize', lazyOnResizeTicket);
    };
  }, []);
  useEffect(() => {
    var _gameSpecificParamete;
    const hostChannel = new HostChannel({
      type: ticketInfo.gameEngineCode,
      name: ticketInfo.type,
      listener
    });
    const gameMode = isDemo ? 'DEMO' : 'NORMAL';
    if ((_gameSpecificParamete = gameSpecificParameters) !== null && _gameSpecificParamete !== void 0 && _gameSpecificParamete.skinId) {
      gameSpecificParameters = _objectSpread(_objectSpread({}, gameSpecificParameters), {}, {
        skinId: svs.ticketgames.ticketUtility.utils.normalizeSkinId(gameSpecificParameters.skinId)
      });
    }
    falcon.openGame({
      hostChannel,
      bridgeLocation,
      parentNode: gameRef.current,
      crossDomain: {
        hostKey,
        authorizedHosts: [window.location.host]
      },
      gameSpecificParameters: _objectSpread(_objectSpread({}, gameSpecificParameters), {}, {
        lockProgress: svs.core.userSession.hasRole(svs.core.userSession.roles.CUSTOMERSERVICE)
      }),
      betId,
      lotteryChannel: voucherCode ? VOUCHER : WEB,
      skipRules: false,
      soundEnabled,
      gameMode,
      theme: isEInstant ? null : ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.theme
    });
    onResize(gameRef.current);
  }, []);
  return React.createElement("div", {
    "aria-atomic": "true",
    "aria-label": "".concat(demoLoadingMsg),
    "aria-live": "polite",
    className: "default-game-launcher ".concat(className),
    ref: gameRef
  }, children);
};
setGlobal('svs.ticketgames.ticketUtility.components.GameLauncherLeia', GameLauncherLeia);

 })(window);